export default __webpack_public_path__ + "static/fleet-81eff381686b1bcd63bf5fec3f83e505.png";